import { useParams } from 'react-router-dom'
import { Link, Navigate } from '../components/nav'
import { useExperimentalFlag } from '../hooks/useExperimentalFlag'
import { useGetProjectQuery, useGetProjectMembersQuery } from '../services/projectDataApi'
import SelfHealingSettings from '../components/SelfHealingSettings'
import ContinuousTestingSetup from '../components/ContinuousTestingSetup'
import { AgentPrompt } from '../components/AgentPrompt'
import ApiTokenControls from '../components/ApiTokenControls'
import '../components/TestingSetup.css'
import './ProjectSupport.css'

const titles: Record<string, string> = {
  'self-healing': 'Self Healing',
  'continuous-testing': 'Continuous Testing',
  security: 'Security',
  'agent-connection': 'Agent Connection',
}

export default function ProjectSupport() {
  const { projectId = '', support = '' } = useParams()
  const flag = useExperimentalFlag('continuous_testing')
  const query = useGetProjectQuery(projectId)
  const members = useGetProjectMembersQuery(projectId)
  const role = members.currentData?.role
  const canEdit = role === 'owner' || role === 'admin' || role === 'member'
  const project = query.currentData
  if (support === 'security') return <Navigate to={`/projects/${projectId}/security`} replace />
  if (!flag.loaded) return <p role="status">Loading…</p>
  if (!flag.enabled || !Object.hasOwn(titles, support)) return <Navigate to={`/projects/${projectId}/overview`} replace />
  return <div className="project-support" data-testid="project-support-page">
    <header className="project-support__header">
    <Link to={`/projects/${projectId}/overview`}>← Overview</Link>
    <h1>{titles[support]}</h1>
    </header>
    <div className="project-support__content">
    {query.isLoading && <p role="status">Loading project…</p>}
    {query.isError && <p role="alert">Could not load project. <button onClick={() => void query.refetch()}>Retry</button></p>}
    {project && <>
      {support === 'self-healing' && <SelfHealingSettings key={projectId} projectId={projectId} />}
      {support === 'continuous-testing' && <ContinuousTestingSetup key={projectId} projectId={projectId} canEdit={canEdit} />}
      {support === 'agent-connection' && <>
        <p>Your coding agent can use Replay QA directly. Give it this prompt:</p>
        <AgentPrompt analyticsEvent="support-agent-prompt-copy" />
        <h2>API tokens</h2>
        <p>Create a token when your agent asks for one. Tokens belong to your account and can be used across your projects.</p>
        <ApiTokenControls />
      </>}
    </>}
    </div>
  </div>
}
